import { useState } from 'react'

import { Alert } from '@/components/ui/Alert'
import { Button } from '@/components/ui/Button'
import { Modal } from '@/components/ui/Modal'
import { useUpdateVenueReservationSetting } from '@/hooks/useUpdateVenueReservationSetting'
import { ApiError, toApiError } from '@/lib/api/errors'
import { RESERVATION_DISABLE_GUIDE_LINES } from '@/lib/venue/reservationSettingViewModel'

/**
 * OFF 확인 모달(이슈 "OFF 전환 시 확인 모달 노출. 확인해야만 전환").
 *
 * 🚨 `PromotionSendConfirmModal`류의 "확인 전 대상 재조회" 패턴은 필요 없다 — 끄기는 서버가
 * 전제조건 없이 항상 허용한다(#757 §2 "끄기는 전제조건을 보지 않는다"). 그래서 mount 시 별도
 * 조회 없이 안내 4줄(정적, 이슈 원문)만 보여주고 확정 클릭 시 바로 `PUT {enabled:false}`.
 */
export function ReservationSettingDisableConfirmModal({
  venueId,
  onClose,
  onDisabled,
}: {
  venueId: string
  onClose: () => void
  onDisabled: () => void
}) {
  const updateMutation = useUpdateVenueReservationSetting(venueId)
  const [error, setError] = useState<ApiError | null>(null)

  async function handleConfirm() {
    setError(null)
    try {
      await updateMutation.mutateAsync({ enabled: false })
      onDisabled()
    } catch (thrown) {
      setError(toApiError(thrown))
    }
  }

  return (
    <Modal title="예약 기능을 끌까요?" onClose={onClose}>
      <div className="space-y-4">
        <Alert tone="warning">
          <ul className="list-disc space-y-1 pl-4">
            {RESERVATION_DISABLE_GUIDE_LINES.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        </Alert>

        {error ? (
          <Alert tone="danger">
            <p>{error.message}</p>
          </Alert>
        ) : null}

        <div className="flex justify-end gap-2 pt-2">
          <Button type="button" variant="secondary" onClick={onClose} disabled={updateMutation.isPending}>
            취소
          </Button>
          <Button
            type="button"
            disabled={updateMutation.isPending}
            onClick={() => {
              void handleConfirm()
            }}
          >
            {updateMutation.isPending ? '처리 중…' : '끄기 확정'}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
